require('./dist/angular-auth0');
module.exports = 'auth0.auth0';



//////////////////
// WEBPACK FOOTER
// ./~/angular-auth0/index.js
// module id = 421
// module chunks = 0